<template>
    <div>
      <vx-card>
        <div v-if="is_skeleton">
          <a-skeleton active />
        </div>
        <div v-else class="flex space-x-4">
          <div class="flex flex-col" v-if="matter">
            <div class="self-center font-semibold text-xl">{{ matter.title }}</div>
            <small id="body_matter">{{ matter.description }}</small>
          </div>
        </div>
      </vx-card>
      <vx-card class="mt-5">
        <div v-if="is_skeleton">
          <a-skeleton active avatar />
        </div>
        <a-tabs v-model="tab" v-else default-active-key="1" :tabBarStyle="{ width: '99%',margin: 'auto' }">
          <a-tab-pane key="1" tab="Dashboard">
            <div class="grid grid-cols-3 gap-4 mx-auto my-5 border" style="width: 99%">
              <div class="col-span-2 grid grid-cols-3 gap-4 p-5" id="border-dashboard">
                <a-card class="flex flex-col justify-center text-center">
                  <h5 class="text-center">Work in progress</h5>
                  <p class="font-semibold"> {{ 'RM' + work_progress.total_unpaid_amount }}</p>
                </a-card>
                <a-card class="flex flex-col justify-center text-center">
                  <h5 class="text-center">Outstanding balance</h5>
                  <p class="font-semibold"> {{ 'RM' + work_progress.outstanding_balance }}</p>
                </a-card>
                <a-card class="flex flex-col justify-center text-center">
                    <h5 class="text-center">Client funds (matter)</h5>
                    <p class="font-semibold"> {{ 'RM' + work_progress.client_funds }}</p>
                </a-card>

                <div v-if="work_progress" class="col-span-2 flex flex-col justify-between items-center md:flex-row">
                  <div>
                     Time: {{ work_progress.total_time ? work_progress.total_time : "0.00" }}hr
                    <a-button @click="tab = '2'" class="ml-5" style="border-radius: 3px !important;">Add time</a-button>
                  </div>
                  <div>
                    Expenses: {{ 'RM' + (work_progress.total_expense ? work_progress.total_expense : "0.00") }}
                    <a-button @click="tab = '2'" class="ml-5" style="border-radius: 3px !important;">Add expense</a-button>
                  </div>
                </div>

              </div>
              <div>
                <a-card title="Contact" v-if="matter.client">
                  <div class="flex space-x-4">
                    <a-avatar shape="square" icon="user" />
                    <div class="self-center font-semibold text-xl	">
                      <a-button type="link" class="p-0" @click="()=>$router.push(`/contacts/dashboard/${matter.client.id}`)">
                        <template v-if="matter.client.person">
                          {{ matter.client.person.first_name }} {{ matter.client.person.last_name }}
                        </template>
                        <template v-else>
                          {{ matter.client.company.name }}
                        </template>
                      </a-button>
                    </div>
                  </div>

                  <a-descriptions :column="1" class="mt-5">
                    <a-descriptions-item label="Phone" >
                      <template class="mt-5" v-if="matter.client.phones.length" v-for="phone in matter.client.phones.slice(0,3)">
                        <a :href="`tel:${phone.phone_number}`">{{ phone.phone_number }}</a>
                      </template>
                    </a-descriptions-item>
                    <a-descriptions-item label="Email">
                      <template class="mt-5" v-if="matter.client.emails.length" v-for="email in matter.client.emails.slice(0,3)">
                        <a :href="`mailto:${email.email_address}`">{{ email.email_address }}</a>
                      </template>
                    </a-descriptions-item>
                    <a-descriptions-item label="Website" >
                      <template class="mt-5" v-for="website in matter.client.websites.slice(0,3)">
                        <a :href="website.website_address">{{ website.website_address }}</a>
                      </template>
                    </a-descriptions-item>
                  </a-descriptions>

                </a-card>
              </div>
            </div>
            <div class="grid grid-cols-1 md:grid-cols-3 gap-4 mx-auto my-5" style="width: 99%">
              <div>
                <div v-if="is_skeleton">
                  <a-skeleton active />
                </div>
                <a-card v-else title="Details" >
                  <a-descriptions :column="1" class="">
                    <a-descriptions-item label="Status" class="!font-bold">
                      {{ matterStatus(matter.status) }}
                    </a-descriptions-item>
                    <a-descriptions-item label="Matter description">
                      {{ matter.description || '__' }}
                    </a-descriptions-item>
                    <a-descriptions-item label="Practice Area" v-if="matter.practice_area">
                      {{ matter.practice_area.title || '__'}}
                    </a-descriptions-item>
                    <a-descriptions-item label="Client reference number">
                      {{ matter.reference_code || '__'}}
                    </a-descriptions-item>
                    <a-descriptions-item label="Location">
                      {{ matter.location || '__'}}
                    </a-descriptions-item>
                    <a-descriptions-item label="Open date ">
                      {{ matter.open_date || '__'}}
                    </a-descriptions-item>
                    <a-descriptions-item label="Closed date">
                      {{ matter.closed_date || '__'}}
                    </a-descriptions-item>
                    <a-descriptions-item label="Limitations date">
                      {{ matter.limitation_date || '__'}}
                    </a-descriptions-item>
                    <a-descriptions-item label="Originating Lawyer">
                      <ATag v-for="org in matter.origination">
                        {{ org.first_name + ' ' + org.last_name }}
                      </ATag>
                    </a-descriptions-item>
                    <a-descriptions-item label="Responsible Lawyer">
                      <ATag v-for="res in matter.responsible">
                        {{ res.first_name + ' ' + res.last_name }}
                      </ATag>
                    </a-descriptions-item>
                  </a-descriptions>
                </a-card>
              </div>
              <a-card title="Time line">
                <a-list item-layout="horizontal" :data-source="time_line">
                  <a-list-item slot="renderItem" slot-scope="item, index">
                    <template slot="actions">{{ moment(item.created_at_formatted) }}</template>
                    <a-list-item-meta>
                      <template slot="description">
                        {{ item.lawyer_user.first_name }} {{ item.lawyer_user.last_name }} {{ item.action }} {{ item.model }}
                        <span>{{ item.row.title }}</span>
                      </template>
                    </a-list-item-meta>
                  </a-list-item>
                </a-list>
              </a-card>
              <a-card title="Related Contacts">
                <div class="flex justify-between gap-2">
                  <div class="flex flex-col">
                    <strong>Contact</strong>
                    <div v-for="related_contcat in matter.relations">
                      {{
                        related_contcat.contact.person ?
                          related_contcat.contact.person.first_name + ' ' + related_contcat.contact.person.last_name
                          : related_contcat.contact.company.name
                      }}
                    </div>
                  </div>
                  <div class="flex flex-col">
                    <strong>Relationship</strong>
                    <div v-for="related_contcat in matter.relations">
                      {{ related_contcat.relationship }}
                    </div>
                  </div>
                </div>
              </a-card>
            </div>
          </a-tab-pane>
          <a-tab-pane key="2" tab="Activities">
            <ListActivitiesMatter ref="Activity" class="mx-auto my-5" style="width: 99%"/>
          </a-tab-pane>
          <a-tab-pane key="3" tab="Documents">
            <ListDoumentMatter ref="document" class="mx-auto my-5" style="width: 99%"/>
          </a-tab-pane>
          <a-tab-pane key="4" tab="Notes">
            <ListNotesMatter ref="note" class="mx-auto my-5" style="width: 99%" />
          </a-tab-pane>
          <a-tab-pane key="5" tab="Tasks">
            <ListTaskMatter ref="task" class="mx-auto my-5" style="width: 99%" />
          </a-tab-pane>
<!--          <a-tab-pane key="6" tab="Bills" force-render>-->
<!--            <ListBillMatter ref="bill" class="mx-auto my-5" style="width: 99%"/>-->
<!--          </a-tab-pane>-->
          <a-tab-pane key="7" tab="Communications">
            <ListCommunicationMatter ref="communication" class="mx-auto my-5" style="width: 99%"/>
          </a-tab-pane>
          <a-tab-pane key="8" tab="Calender">
            <ListCalenderMatter ref="calender" class="mx-auto my-5" style="width: 99%"/>
          </a-tab-pane>
        </a-tabs>
      </vx-card>
    </div>
</template>

<script>
import axios from "@/axios";
import ListActivitiesMatter from "./ListActivitiesMatter";
import ListDoumentMatter from "./ListDoumentMatter";
import ListNotesMatter from "./ListNotesMatter";
import ListTaskMatter from "./ListTaskMatter";
import ListBillMatter from "./ListBillMatter";
import ListCommunicationMatter from "./ListCommunicationMatter";
import ListCalenderMatter from "./ListCalenderMatter";
import moment from "moment";


export default {
  name: "DashboardMatters",
  components:{
    ListActivitiesMatter,
    ListDoumentMatter,
    ListNotesMatter,
    ListTaskMatter,
    ListBillMatter,
    ListCommunicationMatter,
    ListCalenderMatter
  },
  data(){
    return{
      is_skeleton: false,
      matter: {},
      bills: {},
      work_progress: {},
      sum_time: null,
      sum_expense: null,
      tab: '1',
      time_line: []
    }
  },
  methods:{
    matterStatus(status){
      if(status === 1)
        return 'Open'
      else if(status === 2)
        return 'Closed'
      else if(status === 3)
        return 'Pending'
    },
    tabClick(value){
      const matter_id = this.$store.state.dashboard_contact_id || this.$route.params.id
      if(value === '2'){
         this.$refs.Activity.$refs.Activities.data = []
         this.$refs.Activity.$refs.Activities.query.query  = [{ field: 'matter__id',value: matter_id ,condition: '=' }]
         this.$refs.Activity.$refs.Activities.fetch()
      }else if(value === '3'){
        this.$refs.document.$refs.document.data = []
        this.$refs.document.$refs.document.query.query = [{ field: 'matter__id',condition: '=',value: this.$store.state.dashboard_contact_id || this.$route.params.id }]
        this.$refs.document.$refs.document.fetch()
      }else if(value === '4'){
        this.$refs.note.$refs.note.data = []
        this.$refs.note.$refs.note.query.query = [{ field: 'matter__id',condition: '=' , value: this.$store.state.dashboard_contact_id || this.$route.params.id  }]
        this.$refs.note.$refs.note.fetch()
      }else if(value === '5'){
        this.$refs.task.$refs.task.data = []
        this.$refs.task.$refs.task.query.query = [{ field: 'matter__id',value: matter_id , condition: '=' }]
        this.$refs.task.$refs.task.fetch()
      }else if(value === '6'){
        this.$refs.bill.$refs.bill.data = []
        this.$refs.bill.$refs.bill.query.query = [{ condition: 'in' , value: [matter_id] , field: 'matters__id'  }]
        this.$refs.bill.$refs.bill.fetch()
      }else if(value === '7'){
        this.$refs.communication.$refs.phone.data = []
        this.$refs.communication.$refs.phone.query.query = [{ field: 'matter__id',value: matter_id , condition: '=' }]
        this.$refs.communication.$refs.phone.fetch()
      }else if(value === '8'){
        this.$refs.calender.$refs.calender.data = []
        this.$refs.calender.$refs.calender.query.query = [{ field:'matter__id',value: matter_id , condition: '=' }]
        this.$refs.calender.$refs.calender.fetch()
      }
    },
    async getOneMatter(){
      try{
        this.is_skeleton = true
        const matter_id = this.$store.state.dashboard_contact_id || this.$route.params.id
        const { data } = await axios.get(`/matter/${matter_id}/`)
        this.matter = data
      }catch (e) {
        //this.$message.error('Error receiving information')
        throw new Error(e)
      }finally {
        this.is_skeleton = false
      }
    },
    async getWorkProgress(){
      try{
        this.is_skeleton = true
        const matter_id = this.$store.state.dashboard_contact_id || this.$route.params.id
        const { data } = await axios.get(`/matter/${matter_id}/dashboard/`)
        console.log(data,'dada')
        this.work_progress = data
      }catch (e) {
       // this.$message.error('Error receiving information')
        throw new Error(e)
      }finally {
        this.is_skeleton = false
      }
    },
    async getSumTime(){
      const matter_id = this.$store.state.dashboard_contact_id || this.$route.params.id
      const { data } = await axios.post('/activity/time-entry/query/',{ limit: 9999,query:[{ field: 'matter__id',value: matter_id ,condition: '=' }] })
      this.sum_time = data.rows.reduce((duration,item)=> duration + item.duration ,0)
    },
    async getSumExpense(){
      const matter_id = this.$store.state.dashboard_contact_id || this.$route.params.id
      const { data } = await axios.post('/activity/expense-entry/query/',{ limit: 9999, query:[{ field: 'matter__id',value: matter_id ,condition: '=' }] })
      this.sum_expense = data.rows.filter(item=> !item.is_used_in_invoice).reduce((duration,item)=> duration + (item.rate * item.quantity) ,0)
    },
    async getTimeLine(){
      try{
        this.is_skeleton = true
        const {data}     = await axios.post('/timeline/firm/')
        this.time_line   = data.filter(({ row })=> row.id === Number(this.$route.params.id))
      }catch (e) {
        this.is_skeleton = true
        this.$message.error('Error receiving data.')
      }finally {
        this.is_skeleton = false
      }
    },
    moment(date) {
      return moment(date).fromNow()
    },
  },
  mounted() {
    this.getOneMatter()
    this.getWorkProgress()
    this.getSumTime()
    this.getSumExpense()
  //  this.getOutStandingBalance()
    this.getTimeLine()
  }
}
</script>

<style >
  #border-dashboard{
    border: 1px solid #e8e8e8;
    border-radius: 6px !important;
  }
  #body_matter{
    overflow: hidden;
    text-overflow: ellipsis;
  }
  #border-dashboard .ant-card-bordered{
    border-radius: 0 !important;
  }
</style>
<!--class="mx-auto my-5" style="width: 99%"-->
